<template>
    <div class="product-tile flex-col" data-tile="1" :data-itemNum="item.usfitem">
        <!-- Favorite -->
        <div class="product-tile-favorite flex-col">
            <a class="star" title="Add to favorites" href="javascript:void(0);" data-converted="1"
                :class="{'active': sessionStore.userFavorites.favoritesList.includes(item.usfitem)}" 
                :data-id="item.itemID[sessionStore.storeNum]" 
                :data-sfitem="item.usfitem"
                @click="sendFavoriteEvent(item)"
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><path d="M500 60.7l119.3 335.7h320.1l-261.2 197 93.4 345.9L500 731.9 228.5 939.3l93.4-345.9L60.6 396.3h320.1L500 60.7h0z" stroke-width="34" stroke-miterlimit="10"/></svg>
            </a>
        </div>

        <!-- Desktop Add Widget -->
        <div class="product-tile-widget-container hideAt600">
            <SearchProductAddWidget 
                :item="item"
                :itemDesc="itemDesc" />
        </div>

        <a class="product-tile-link flex-col" 
            :href="getPdpUrl"
            :data-item="item.itemID[sessionStore.storeNum]" 
            :aria-label="itemDesc" 
            :title="itemDesc" 
            :class="{ 'is-special': item.showUnitSale[sessionStore.storeNum] == 1}"
            @mousedown="handleTileClick(state, item, 'Result Clicked')">


            <!--- Mobile Image --->
            <div class="product-tile-image show-grid-at-600">
                <SearchProductImage 
                    :item="item"
                    :itemDesc="itemDesc"
                />
            </div>

            <div class="product-tile-container-top">
                <!-- Title -->
                <div class="product-tile-title flex-col">
                    {{ itemDesc }}
                    <span class="product-tile-number">#{{ item.usfitem }}</span>
                </div>

                <!-- Desktop Image -->
                <div class="product-tile-image flex-col hideAt600">
                    <SearchProductImage 
                        :item="item"
                        :itemDesc="itemDesc"
                    />
                </div>
            </div>

            <div class="product-tile-container-bottom" 
                :class="{ 'row-2': item.hasCase[sessionStore.storeNum] == 1 && item.toMultiply[sessionStore.storeNum] == 1, 'col-3': item.showUnitSale[sessionStore.storeNum] == 1 || item.showCaseSale[sessionStore.storeNum] == 1, 'col-2': item.showUnitSale[sessionStore.storeNum] == 0 && item.showCaseSale[sessionStore.storeNum] == 0 }"
            >
                <!-- Unit info -->
                <div v-if="item.itemExists[sessionStore.storeNum] > 0" class="product-size flex-col hideAt600">{{ item.itemSize[sessionStore.storeNum] }}</div>

                <div v-if="item.itemExists[sessionStore.storeNum] > 0" class="product-tile-price-wrapper flex-col">
                    <div class="product-tile-price flex-row" :class="{ 'is-sale': item.showUnitSale[sessionStore.storeNum] == 1}">
                        <span class="product-price-dollar">$</span>
                        <span class="product-price">{{ getUnitFirst }}</span>
                        <div class="flex-col">
                            <span class="product-price-cents">.{{ getUnitLast }}</span>
                            <span class="product-price-label">{{ getLabel }}</span>
                        </div>
                    </div>
                </div>

                <div v-if="item.itemExists[sessionStore.storeNum] > 0 && (item.showUnitSale[sessionStore.storeNum] == 1 || item.showCaseSale[sessionStore.storeNum] == 1)" class="flex-col">
                    <div v-if="item.showUnitSale[sessionStore.storeNum] == 1" class="product-item-info flex-row">
                        <div class="strikethrough gray">${{ item.unitRegPrice[sessionStore.storeNum] }}</div>
                        <div class="product-size flex-col showAt600">{{ item.itemSize[sessionStore.storeNum] }}</div>
                    </div>

                    <div v-if="item.showUnitSale[sessionStore.storeNum] == 1 && item.unitSavings[sessionStore.storeNum] > 0" class="product-tile-savings" :data-id="item.itemID[sessionStore.storeNum]">
                        Save {{ item.unitSavings[sessionStore.storeNum] }}%
                    </div>
                </div>

                <div v-if="item.itemExists[sessionStore.storeNum] > 0 && (item.showUnitSale[sessionStore.storeNum] == 0 || (item.showCaseSale[sessionStore.storeNum] == 0 && item.toMultiply[sessionStore.storeNum] == 1))" class="product-size flex-col showAt600">{{ item.itemSize[sessionStore.storeNum] }}</div>

                <!-- Case info -->
                <div v-if="item.hasCase[sessionStore.storeNum] == 1 && item.toMultiply[sessionStore.storeNum] == 1" class="product-size flex-col hideAt600">{{ item.pack[sessionStore.storeNum] }}&nbsp;units</div>

                <div v-if="item.hasCase[sessionStore.storeNum] == 1 && item.toMultiply[sessionStore.storeNum] == 1" class="product-tile-price-wrapper flex-col">
                    <div class="product-tile-price flex-row" :class="{ 'is-sale': item.showCaseSale[sessionStore.storeNum] == 1 }">
                        <span class="product-price-dollar">$</span>
                        <span class="product-price">{{ getCaseFirst }}</span>
                        <div class="flex-col">
                            <span class="product-price-cents">.{{ getCaseLast }}</span>
                            <span class="product-price-label">Case</span>
                        </div>
                    </div>
                </div>

                <div v-if="item.hasCase[sessionStore.storeNum] == 1 && item.toMultiply[sessionStore.storeNum] == 1 && (item.showCaseSale[sessionStore.storeNum] == 1 || item.showUnitSale[sessionStore.storeNum] == 1)" class="flex-col">
                    <div v-if="item.showCaseSale[sessionStore.storeNum] == 1" class="product-item-info flex-row">
                        <div class="gray strikethrough">${{ item.caseRegPrice[sessionStore.storeNum] }}</div>
                        <div class="product-size flex-col showAt600">{{ item.pack[sessionStore.storeNum] }}&nbsp;units</div>
                    </div>

                    <div v-if="item.showCaseSale[sessionStore.storeNum] == 1 && item.caseSavings[sessionStore.storeNum] > 0" class="product-tile-savings" :data-id="item.itemID[sessionStore.storeNum]">
                        Save {{ item.caseSavings[sessionStore.storeNum] }}%
                    </div>
                </div>

                <div v-if="item.hasCase[sessionStore.storeNum] == 1 && item.toMultiply[sessionStore.storeNum] == 1 && item.showCaseSale[sessionStore.storeNum] == 0 && item.showUnitSale[sessionStore.storeNum] == 0" class="product-size flex-col showAt600">{{ item.pack[sessionStore.storeNum] }}&nbsp;units</div>
            </div>

            <!-- The special message spacer -->
            <div class="product-tile-message not-visible" aria-hidden="true"
                :class="{ 'list-only': getMessage.length <= 0 && getUnitQty <= 20 && getCaseQty <= 20, 'has-low-stock': item.lowStock[sessionStore.storeNum] > 0 && sessionStore.hasStore }"
            >
                {{ getMessage }}
                <div class="qty-over-20"
                    :class="{ 'has-margin': getMessage.length > 0 && !hasAvailableMsg, 'is-hidden': getUnitQty <= 20 && getCaseQty <= 20 }"
                >
                    For quantities over 20, please call {{ sessionStore.userStore.storePhone }} for availability.
                </div>
            </div>
        </a>

        <!-- Lower Links -->
        <div class="tile-link-container"
            :class="{'list-only': getMessage.length <= 0 && getUnitQty <= 20 && getCaseQty <= 20}">
            <!-- Add to List -->
            <a class="list-link openListModal" href="javascript:void(0);" 
                :data-usfitem="item.usfitem"
            >
                <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 33.907 36.401" xml:space="preserve"><path data-name="Path 1065" class="has-fill" d="M8.964 0l-1.6 24.436H0v6.236A5.7 5.7 0 005.729 36.4h20.032c3.508 0 5.729-2.221 6.236-6.275.429-3.352 1.793-27.515 1.832-28.567l.078-1.442zM5.729 33.673a3.021 3.021 0 01-3-3v-3.509h17.5v2.806a7.134 7.134 0 00.935 3.7zm23.579-3.9c-.429 3.43-2.027 3.858-3.508 3.858-1.364 0-2.806-1.169-2.806-3.7v-5.5h-12.9L11.5 2.767l19.525.078c-.314 5.378-1.367 24.163-1.717 26.93z"/><path data-name="Rectangle 161" d="M15.589 7.093h10.912v2.338H15.589z"/><path data-name="Rectangle 162" d="M15.199 11.497h11.068v2.338H15.199z"/><path data-name="Rectangle 163" d="M14.849 15.979h2.221v2.338h-2.221z"/><path data-name="Rectangle 164" d="M19.097 15.979h4.56v2.338h-4.56z"/></svg> List&nbsp;&plus;
            </a>

            <!-- Mobile Add Widget -->
            <div class="product-tile-widget-container showAt600">
                <SearchProductAddWidget 
                    :item="item" 
                    :itemDesc="itemDesc" />
            </div>

            <!-- Special messaging -->
            <div class="product-tile-message"
                :class="{ 'is-hidden': getMessage.length <= 0 }"
            >
                <span v-if="getMessage.length > 0" 
                    :class="{'has-show-hide': hasAvailableMsg, 'is-hidden': hasAvailableMsg && (getUnitQty > 20 || getCaseQty > 20)}"
                    v-html="getMessage">
                </span>
                
                <div class="qty-over-20"
                    :class="{ 'has-margin': getMessage.length > 0 && !hasAvailableMsg, 'is-hidden': getUnitQty <= 20 && getCaseQty <= 20}"
                >
                    For quantities over 20, please call <span v-html="sessionStore.userStore.storePhoneLink"></span> for availability.
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import SearchProductAddWidget from './SearchProductAddWidget.vue';
    import SearchProductImage from './SearchProductImage.vue';
    import { computed, ref } from 'vue';
    import { format, parseISO } from 'date-fns';
    import { useSessionStore } from "@/store/storeSession.js";
    import { initAlgoliaInsights, sendAlgoliaEvent } from "@/utils/algoliaInsights.js";
    import { buildPdpUrl } from '@/utils/algoliaSearch.js';

    const sessionStore = useSessionStore();

    initAlgoliaInsights(sessionStore);

    const props = defineProps({
        item: {
            type: Object,
            required: true,
            default: () => ({
                itemID: 0,
                usfitem: '',
                itemDesc1: '',
                itemDesc2: '',
                itemDescStore: [],
                unitSellPrice: [0],
                unitRegPrice: [0],
                caseSellPrice: [0],
                caseRegPrice: [0],
                scaleItem: [0],
                toMultiply: [1],
                showSpecial: [0],
                image: '',
                hasCase: [0],
                itemSize: [],
                pack: [0],
                showUnitSale: [0],
                showCaseSale: [0],
                isExclusiveBrand: [0],
                unitSavings: [0],
                caseSavings: [0],
                itemExists: [1],
                lowStock: [0],
                invalidData: [0],
            })
        },
        itemDesc: String,
        state: Object,
        query: String,
        filters: [Object, String]
    });

    const getExpiredItem = computed(() => {
        let usfitem = String(props.item.usfitem || '');
        return sessionStore.expiredItems?.[usfitem] || null;
    });

    function getPriceParts(value) {
        let price = String(value ?? '0');
        let parts = price.split('.');
        return {
            first: parts[0] || '0',
            last: parts[1] || ''
        };
    }

    const getUnitPrice = computed(() => {
        if (getExpiredItem.value && getExpiredItem.value.UNITSELLPRICE !== undefined) {
            return getExpiredItem.value.UNITSELLPRICE;
        }

        return props.item.unitSellPrice[sessionStore.storeNum];
    });

    const getCasePrice = computed(() => {
        if (getExpiredItem.value && getExpiredItem.value.CASESELLPRICE !== undefined) {
            return getExpiredItem.value.CASESELLPRICE;
        }

        return props.item.caseSellPrice[sessionStore.storeNum];
    });

    const getUnitFirst = computed(() => { return getPriceParts(getUnitPrice.value).first; });
    const getUnitLast  = computed(() => { return getPriceParts(getUnitPrice.value).last; });
    const getCaseFirst = computed(() => { return getPriceParts(getCasePrice.value).first; });
    const getCaseLast  = computed(() => { return getPriceParts(getCasePrice.value).last; });

    const getPdpUrl = computed(() => {
        return buildPdpUrl(props.itemDesc, props.item.usfitem);
    });

    const getLabel = computed(() => {
        if(props.item.scaleItem[sessionStore.storeNum] > 0)
            return 'lb';
        else
            return 'Unit';
    });

    const getMessage = computed(() => {
        try {
            let message = '';
            let unitDisabled = getUnitDisabled.value;
            let caseDisabled = getCaseDisabled.value;

            if(sessionStore.userStore.hasStore <= 0) {
                message = 'Select a store to see pricing and availability.';
            } else if(unitDisabled && caseDisabled && sessionStore.userStore.freezerClosedMessage.length > 0) {
                message = sessionStore.userStore.freezerClosedMessage;
            } else if(sessionStore.userStore.hasStore > 0 && props.item.itemExists[sessionStore.storeNum] == 0) {
                message = 'Call ' + sessionStore.userStore.storePhoneLink + ' for availability';
            } else if(props.item.invalidData[sessionStore.storeNum] > 0) {
                message = 'Product info may differ in store';
            }else if(props.item.showSpecial[sessionStore.storeNum] > 0) {
                const endDate = props.item.unitEndDate?.[sessionStore.storeNum]?.trim();
                if(endDate) {
                    const parsedDate = parseISO(endDate);
                    if (!isNaN(new Date(parsedDate).getTime())) {
                        message = 'Sale Ends ' + format(new Date(parsedDate), 'M/dd/yyyy');
                    } else {
                        message = 'Sale Ends ' + endDate;
                    }
                }
            } else if(props.item.scaleItem[sessionStore.storeNum] > 0) {
                message = 'Item sold per lb.';
            }

            return message;
        } catch (error) {
            return '';
        }
    });

    const getUnitDisabled = computed(() => {
        let isFrozenCategory = [
            'frozen', 'fzn', 'ICE CREAM, HARD PACKED', 'ICE CREAM, CUPS & NOVELTIES'
        ].some(keyword => 
            (props.itemDesc && props.itemDesc.toLowerCase().includes(keyword)) || 
            (props.item.category && props.item.category.toLowerCase().includes(keyword)) || 
            (props.item.area[sessionStore.storeNum] && props.item.area[sessionStore.storeNum].toLowerCase().includes(keyword))
        );
        let isFreezerClosed = sessionStore.userStore.freezerClosed == "1";
        let isFreezerClosedCase = sessionStore.userStore.freezerClosedCase == "1";
        let thisHasCase = props.item.hasCase[sessionStore.storeNum] == "1";

        let isUnitDisabled = isFreezerClosed && isFrozenCategory && (thisHasCase || !isFreezerClosedCase);

        return isUnitDisabled;
    });

    const getCaseDisabled = computed(() => {
        let isUnitDisabled = getUnitDisabled.value;
        let isCaseDisabled = isUnitDisabled && sessionStore.userStore.freezerClosedCase == "1";

        return isCaseDisabled;
    });

    const getUnitQty = computed(() => {
        let quantity = 0;

        if (sessionStore.userCartItems[props.item.usfitem])
            quantity = sessionStore.userCartItems[props.item.usfitem].itemQty;

        return quantity;
    });

    const getCaseQty = computed(() => {
        let quantity = 0;

        if (sessionStore.userCartItems[props.item.usfitem])
            quantity = sessionStore.userCartItems[props.item.usfitem].caseQty;

        return quantity;
    });

    const hasAvailableMsg = computed(() => {
        let hasMsg = false;

        if (sessionStore.userStore.hasStore > 0 && props.item.itemExists[sessionStore.storeNum] == 0)
            hasMsg = true;

        return hasMsg;
    });

    function saveSearchState(state) {
        sessionStore.setSearchState(
            state.items.length, 
            String(props.filters || ''),
            String(props.query || ''),
            window.scrollY, 
            window.location.href);
    }

    function sendViewEvent(item, eventName) {
        if(!sessionStore.trackAlgolia)
            return;

        if (!item || !item.objectID) {
            return;
        }

        if(item.__queryID)
            sessionStore.setQueryID(item.__queryID, item.__position);

        sendAlgoliaEvent(sessionStore, "viewedObjectIDs", {
            eventType: 'view',
            eventName: eventName,
            queryID: item.__queryID,
            index: sessionStore.index,
            objectIDs: [item.objectID],
            userToken: sessionStore.userToken || "",
            authenticatedUserToken: sessionStore.authUserToken || "",
        });
    }

    async function handleTileClick(state, item, eventName) {
        saveSearchState(state);
        sendViewEvent(item, eventName);
    }

    const favoriteEventName = ref();

    function sendFavoriteEvent(item) {
        if(!sessionStore.trackAlgolia) return;
        if (!item || !item.itemID[sessionStore.storeNum]) return;

        if(favoriteEventName.value === null || favoriteEventName.value === undefined) {
            favoriteEventName.value =
                sessionStore.userFavorites.favoritesList.includes(props.item.usfitem) ? 'Remove Favorite' : 'Add Favorite'
        } else {
            favoriteEventName.value = 
                favoriteEventName.value === 'Add Favorite' ? 'Remove Favorite' : 'Add Favorite';
        }

        if(item.__queryID)
            sessionStore.setQueryID(item.__queryID, item.__position);

        let algoliaEvent = 'clickedObjectIDs';

        sendAlgoliaEvent(sessionStore, algoliaEvent, {
            eventType: 'click',
            eventName: favoriteEventName.value,
            queryID: item.__queryID,
            index: sessionStore.index,
            objectIDs: [item.objectID],
            positions: [item.__position],
            userToken: sessionStore.userToken || "",
            authenticatedUserToken: sessionStore.authUserToken || "",
        });

        sessionStore.getUserFavorites();
    }
</script>
